'use client';

import dynamic from 'next/dynamic';

const CameraContent = dynamic(() => import('./camera-content'), { ssr: false });

export default function CameraPage() {
  return <CameraContent />;
}

